import { LayoutType } from '@/types';
import { createContext } from '@lit/context';

export interface GlobalComponentType {
  /** The layout type of the component. */
  layout: LayoutType;
  /** The locale of the component. */
  locale: string;
  /** The base URL of the component. */
  baseUrl: string;
  /** Overall placeholder determined in engine (CE). */
  placeholder?: string;
  /** Indicates if the user is logged in (optional). */
  loggedIn?: boolean;
  /** The country of the user (optional). */
  country?: string;
  /** The debtor information (optional). */
  debtor?: string;
  /** The customer ID (optional). */
  customerId?: number;
  /** The VAT rate (optional). */
  vatRate?: string;
}

export const global = {
  context: createContext<GlobalComponentType>(Symbol('ComponentContext')),
};
